var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1853 7.69625C23.1525 7.62219 22.3584 5.86062 20.5931 4.09531C18.2409 1.74312 15.27 0.5 12 0.5C8.73 0.5 5.75906 1.74312 3.40687 4.09531C1.64156 5.86062 0.84375 7.625 0.814687 7.69625C0.728449 7.89022 0.728449 8.11165 0.814687 8.30562C0.8475 8.37969 1.64156 10.1403 3.40687 11.9056C5.75906 14.2569 8.73 15.5 12 15.5C15.27 15.5 18.2409 14.2569 20.5931 11.9056C22.3584 10.1403 23.1525 8.37969 23.1853 8.30562C23.2716 8.11165 23.2716 7.89022 23.1853 7.69625ZM12 14C9.11438 14 6.59344 12.9509 4.50656 10.8828C3.65029 10.0313 2.9218 9.06027 2.34375 8C2.92165 6.93963 3.65015 5.9686 4.50656 5.11719C6.59344 3.04906 9.11438 2 12 2C14.8856 2 17.4066 3.04906 19.4934 5.11719C20.3514 5.9684 21.0815 6.93942 21.6609 8C20.985 9.26188 18.0403 14 12 14ZM12 3.5C9.51472 3.5 7.5 5.51472 7.5 8C7.5 10.4853 9.51472 12.5 12 12.5C14.4853 12.5 16.5 10.4853 16.5 8C16.4974 5.51579 14.4842 3.50258 12 3.5ZM12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8C15 9.65685 13.6569 11 12 11Z",
    fill: "#082C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1385c671303d93730183ee848c2e4ddd.svg";
export { ForwardRef as ReactComponent };